import { Repository } from '../../../core/context/repository';
import { type Scope } from './entity';

export class Scopes extends Repository<Scope> {}
